const texts = {
  navHome: 'Payper',
  navSearch: 'Buscar',
  navFavorite: 'Favorito',
  navSummary: 'Resumen',
  navCoverage: 'Cobertura',
  navContext: 'Contexto',
  close: 'Cerrar',
  noResultsText: 'No se han encontrado resultados',
  genericError1: 'Se ha producido un error.',
  genericError2: 'Inténtalo de nuevo más tarde.',
  noResultsLabel: 'No se han encontrado resultados',
  unexpectedError: 'Algo fue mal, inténtelo de nuevo más tarde.',
  showMoreLabel: 'Ver más',
  readDate: () => 'Leído',
  publishedDate: () => 'Publicado',
  dateOn: () => ' el ',
  dateSince: () => ' hace ',
  hour: () => ' hora',
  hours: () => ' horas',
  getDeleteAction: () => 'Eliminar',
  free: 'Gratis',
  clearAriaLabel: 'limpiar campo de búsqueda',
  backAriaLabel: 'volver atrás',
  searchPlaceholder: '¿Sobre qué quieres leer?',
  searchAction: 'Buscar',
  bannerPremiumArticle: (customerName: string) =>
    `Esta noticia tiene muro de pago. La puedes leer completa por cortesía de <b>${
      customerName ?? 'Payper'
    }</b>.`,
  okLabel: 'Ok',
  getShowMoreLabel: () => 'Ver más',
  getUnexpectedError: () => 'Algo fue mal, inténtelo de nuevo más tarde.',
  getNoResultsLabel: () => 'No se han encontrado resultados',
  // PAYPER-1177: frases que rotan bajo el reloj de arena mientras se genera.
  // Cortas (1-3 palabras) porque cambian en cada volteo (1,2 s).
  getGeneratingPhrases: (subject: 'resumen' | 'contexto') => [
    'Estamos en ello…',
    'Analizando…',
    'Leyendo con atención…',
    'Atando cabos…',
    'Ordenando ideas…',
    'Buscando lo importante…',
    'Poniendo orden…',
    'Pensando…',
    'Afinando detalles…',
    'Echando cuentas…',
    'Conectando puntos…',
    'Dándole una vuelta…',
    'Calentando motores…',
    'Subrayando lo clave…',
    'Tomando notas…',
    'Hilando fino…',
    ...(subject === 'resumen'
      ? ['Yendo al grano…', 'Destilando lo esencial…', 'Menos es más…']
      : [
          'Tirando del hilo…',
          'Buscando antecedentes…',
          'Poniéndonos al día…',
          'Desempolvando apuntes…',
          'Recopilando pistas…',
          'Siguiendo el rastro…',
          'Revisando las notas…',
          'Refrescando la memoria…',
        ]),
  ],
  // PAYPER-1181: mismo mensaje si el back falla (503) o si se agotan los
  // reintentos sin que termine de generar.
  getGenerationErrorTitle: (subject: string) =>
    `Lo sentimos, no hemos podido generar el ${subject}`,
  getGenerationErrorSubtitle: () => 'Inténtalo de nuevo más tarde',
  // PAYPER-1123: mismo copy para "sin cobertura" y "error al cargar" (de
  // cara al usuario no distinguimos ambos casos, ver Coverage.tsx).
  getCoverageEmptyLabel: () =>
    'No hemos encontrado cobertura sobre este artículo',
}

export default texts
